// extracted by mini-css-extract-plugin
module.exports = {"dryRun":"dryRun","form":"form","dryRunDiv":"dryRunDiv","span":"span","passed":"passed","compareResult":"compareResult"};